import "@backstage/cli/asset-types";
import ReactDOM from "react-dom/client";

import "@backstage/ui/css/styles.css";
import App from "./App";



ReactDOM.createRoot(document.querySelector("#root")!).render(<App />);
